import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import TableResponts from 'views/requests/registration-requests/tableResponts'; // Importing TableResponts component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table responses view.
 * @extends JetView
 */
export default class recordTableRespontsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        var idRequests; // Variable to hold request ID

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Event listener for details response ID
        this.on(this.app, 'detailsResponts:id', (item) => {
            idRequests = item; // Set the request ID
            $$('btn').enable(); // Enable the button when ID is set
        });

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        {
                            view: 'label', // Label for the title
                            label: _('Respuestas de la petición'),
                        },
                        {
                            view: 'button', // Button to add response
                            value: _('Añadir Respuesta'),
                            type: 'form',
                            id: 'btn',
                            disabled: true, // Initially disabled
                            click: () => {
                                // Click event handler
                                if (idRequests.State == '0') {
                                    // Check if request state is '0'
                                    this.app.callEvent('requests:id', [
                                        idRequests, // Call event with request ID
                                    ]);
                                    $$('responts-request').show(); // Show response request
                                } else {
                                    if (idRequests.State == '1') {
                                        // Check if request state is '1'
                                        webix.message({
                                            // Show error message
                                            text: _('La petición debe estar activa'),
                                            title: _('¡Exito!'),
                                            type: 'alert-error',
                                        });
                                    }
                                }
                            },
                        },
                    ],
                },
                TableResponts, // Include TableResponts component
                toolbar, // Include toolbar
            ],
        };

        // Return the main configuration object
        return {
            height: screen.width < 500 ? 500 : 0, // Set height based on screen width
            type: 'wide',
            cols: [left], // Include left panel
        };
    }
}

// FILE DOCUMENTED
